import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SearchApiComponent } from '../components/search-api/search-api.component';
import { ListApiComponent } from '../components/list-api/list-api.component';
import { ApiHistoryFull } from '../models/api-history-full';

@Component({
  selector: 'admin-manage-api-container',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDividerModule,
    MatSelectModule,
    MatCheckboxModule,
    SearchApiComponent,
    ListApiComponent,
  ],
  templateUrl: './manage-api.container.html',
  styleUrls: ['./manage-api.container.scss'],
})
export class ManageApiContainer {
  requests: ApiHistoryFull = {
    items: [
      {
        id: '1',
        propertyType: 'APP',
        clientCode: 'client',
        requestType: 'achat',
        happened_at: '2024-05-16T07:24:28.000+00:00',
        resultCount: '1',
        partner: 'user',
      },
      {
        id: '1',
        propertyType: 'APP',
        clientCode: 'client',
        requestType: 'achat',
        happened_at: '2024-05-16T07:24:28.000+00:00',
        resultCount: '1',
        partner: 'user',
      },
      {
        id: '1',
        propertyType: 'APP',
        clientCode: 'client',
        requestType: 'achat',
        happened_at: '2024-05-16T07:24:28.000+00:00',
        resultCount: '1',
        partner: 'user',
      },
      {
        id: '1',
        propertyType: 'APP',
        clientCode: 'client',
        requestType: 'achat',
        happened_at: '2024-05-16T07:24:28.000+00:00',
        resultCount: '1',
        partner: 'user',
      },
      {
        id: '1',
        propertyType: 'APP',
        clientCode: 'client',
        requestType: 'achat',
        happened_at: '2024-05-16T07:24:28.000+00:00',
        resultCount: '1',
        partner: 'user',
      },
      {
        id: '1',
        propertyType: 'APP',
        clientCode: 'client',
        requestType: 'achat',
        happened_at: '2024-05-16T07:24:28.000+00:00',
        resultCount: '1',
        partner: 'user',
      },
      {
        id: '1',
        propertyType: 'APP',
        clientCode: 'client',
        requestType: 'achat',
        happened_at: '2024-05-16T07:24:28.000+00:00',
        resultCount: '1',
        partner: 'user',
      },
    ],
    totalResult: 20,
  };

  constructor() {}
}
